import React from 'react';
import {Router, Switch, Route} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import {Home} from './Home';
import {Course} from './Course';
import {UI} from './UI';
import {Callback} from "./Callback";
import {HealthCheckMonitor} from "./HealthCheckMonitor";
import {ImageEventListener} from "./components/ImageEventListener/ImageEventListener";
import {CloudDomainRedirectGuard} from "./components/CloudDomainRedirectGuard/CloudDomainRedirectGuard";

const history = createBrowserHistory();

export default function App() {
    return (
        <ImageEventListener>
            <Router history={history}>

                <Switch>
                    <Route path="/callback/course/:id" >
                        <Callback/>
                    </Route>
                    <Route path="/course/:id">
                        <CloudDomainRedirectGuard>
                            <Course/>
                        </CloudDomainRedirectGuard>
                    </Route>
                    <Route path="/tutorial/:id">
                        <CloudDomainRedirectGuard>
                            <Course/>
                        </CloudDomainRedirectGuard>
                    </Route>
                    <Route path="/ui">
                        <HealthCheckMonitor/>
                        <UI/>
                    </Route>
                    <Route path="/">
                        <CloudDomainRedirectGuard>
                            <Home/>
                        </CloudDomainRedirectGuard>
                    </Route>
                </Switch>
            </Router>
        </ImageEventListener>
    );
}
